import { HttpClient } from '@angular/common/http';
import { Injectable, NgModule } from '@angular/core';
import {
  Translation,
  TRANSLOCO_CONFIG,
  TRANSLOCO_LOADER,
  translocoConfig,
  TranslocoLoader,
  TranslocoModule
} from '@ngneat/transloco';

@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
  constructor(private http: HttpClient) {}

  getTranslation(lang: string) {
    if (window.location.href?.includes('me.notlocal.dev')) {
      return this.http.get<Translation>(`/assets/i18n/${lang}.json`);
    }

    return this.http.get<Translation>(
      `/${lang.toLowerCase()}/assets/i18n/${lang}.json`
    );
  }
}

@NgModule({
  exports: [TranslocoModule],
  providers: [
    {
      provide: TRANSLOCO_CONFIG,
      useValue: translocoConfig({
        availableLangs: ['en-US', 'es-MX'],
        defaultLang:
          navigator.language.toLowerCase().substring(0, 2) === 'en'
            ? 'en-US'
            : 'es-MX',
        prodMode: true // environment.production
      })
    },
    { provide: TRANSLOCO_LOADER, useClass: TranslocoHttpLoader }
  ]
})
export class TranslocoRootModule {}
